import './PieChartPlot.css';
export var container = '_uk3k6g0-2-0-1';